import { graphql, useFragment } from "react-relay";

import { config } from "~/data";
import type { hooksOlympicWidgetsQuery$key } from "~/queries/__generated__/hooksOlympicWidgetsQuery.graphql";

export const useOlympicScmpWidgetConfig = (reference?: hooksOlympicWidgetsQuery$key) => {
  const data = useFragment<hooksOlympicWidgetsQuery$key>(
    graphql`
      fragment hooksOlympicWidgetsQuery on Query {
        appConfig(filter: { entityId: "scmp_pwa_widget" }) {
          json
        }
      }
    `,
    reference,
  );

  if (!data?.appConfig?.json) return;
  const raw = data.appConfig.json as OlympicScmpPwaWidgetAppConfig;
  return config.general.env === "production" ? raw.production : raw.dev;
};

export type OlympicScmpPwaWidgetAppConfig = AppConfig<{
  olympics_dpa: {
    medal: {
      enable: string;
    };
    path: string;
    src: string;
  };
  olympics_today_highlight: string;
  olympics_today_highlight_day_1: string;
  olympics_widgets: string;
}>;
